import templateDemoBgUrl from "../Assets/Images/canvas/canvasBgDemo.png";
import { computeCanvasSizeForRatio } from "../core";

/** Bundled demo background for template authoring (no upload required). */
export const TEMPLATE_DEMO_BACKGROUND_URL = String(templateDemoBgUrl);

export type TemplateAspectPresetId =
  | "2:3"
  | "3:2"
  | "3:4"
  | "1:1"
  | "4:3"
  | "9:16"
  | "16:9";

export type TemplateAspectPreset = {
  id: TemplateAspectPresetId;
  label: string;
  /** width / height (matches mobile `value`) */
  ratio: number;
  w: number;
  h: number;
};

/** Same order and ratios as the iOS aspect presets. */
export const TEMPLATE_ASPECT_PRESETS: TemplateAspectPreset[] = [
  { id: "1:1", label: "1:1", ratio: 1, w: 1, h: 1 },
  { id: "2:3", label: "2:3", ratio: 2 / 3, w: 2, h: 3 },
  { id: "3:2", label: "3:2", ratio: 3 / 2, w: 3, h: 2 },
  { id: "3:4", label: "3:4", ratio: 3 / 4, w: 3, h: 4 },
  { id: "4:3", label: "4:3", ratio: 4 / 3, w: 4, h: 3 },
  { id: "9:16", label: "9:16", ratio: 9 / 16, w: 9, h: 16 },
  { id: "16:9", label: "16:9", ratio: 16 / 9, w: 16, h: 9 },
];

/**
 * Fit a canvas with the given width/height ratio inside `availableW x availableH`, mirroring the
 * mobile app's `computeCanvasSizeForRatio(ratio, availableSize)`: whichever axis is the tighter
 * constraint limits the size. Falls back to the single-axis `side` call shape for callers that
 * don't pass a width (keeps back-compat).
 */
export function canvasDimensionsForAspect(
  availableW: number,
  ratioWidthOverHeight: number,
  availableH?: number
): { width: number; height: number } {
  const R = ratioWidthOverHeight;
  const W = Number(availableW) || 0;
  const H = Number.isFinite(availableH) && (availableH as number) > 0 ? (availableH as number) : W;
  if (!Number.isFinite(R) || R <= 0 || W <= 0 || H <= 0) {
    return { width: W, height: H };
  }
  const { width, height } = computeCanvasSizeForRatio(R, { width: W, height: H });
  return { width, height };
}

export function getAspectRatioForPreset(id: TemplateAspectPresetId): number {
  const p = TEMPLATE_ASPECT_PRESETS.find((x) => x.id === id);
  return p?.ratio ?? 1;
}
